import { useRouter } from "@tanstack/react-router"
import { parseAsBoolean, useQueryState } from "nuqs"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui"
import { Button } from "@/components/ui/button"

const PopupPhoneCheck = () => {
  const router = useRouter()
  const [open, setOpen] = useQueryState("popup_phone_check", parseAsBoolean.withDefault(false))
  return (
    <Dialog open={open} onOpenChange={setOpen} modal>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Thiếu số điện thoại</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="space-y-6 text-center">
            <p className="text-sm text-primary-800">
              Vui lòng cập nhật số điện thoại trong{" "}
              <span className="font-medium text-gradient-primary">trang cá nhân</span> để tiến hành
              tiếp tục.
            </p>
            <Button
              className="w-full !h-12 rounded-xll bg-gradient-primary"
              onClick={() => router.navigate({ to: "/profile", search: { tab: "profile" } })}
            >
              <span className="text-white">Cập nhật ngay</span>
            </Button>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  )
}

export default PopupPhoneCheck
